module.exports = {"noData":"Data nejsou k dispozici","tab.distribution":"Rozložení v krajích","tab.ownership":"Listy vlastnictví"}